"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../../core");
exports.ATTRS = "ATTRS";
var AttrType;
(function (AttrType) {
    AttrType["DOM_TRANSPARENT"] = "DOM_TRANSPARENT";
    AttrType["DOM_INTRANSPARENT"] = "DOM_INTRANSPARENT";
})(AttrType = exports.AttrType || (exports.AttrType = {}));
exports.DEFAULT_ATTR_TYPE = AttrType.DOM_INTRANSPARENT;
var AttrTrait = /** @class */ (function () {
    function AttrTrait() {
    }
    AttrTrait.enableFor = function (instance) {
        var attrs = Object.getPrototypeOf(instance).constructor[exports.ATTRS] || {};
        var _loop_1 = function (name_1) {
            Object.defineProperty(instance, name_1, {
                get: function () {
                    return instance.getAttribute(name_1);
                },
                set: function (value) {
                    instance.setAttribute(name_1, value);
                },
                configurable: true
            });
        };
        // add change detection / reflection for all @attrs
        for (var name_1 in attrs) {
            _loop_1(name_1);
        }
    };
    AttrTrait.getType = function (instance, name) {
        var attributeDecorations = Object.getPrototypeOf(instance).constructor[exports.ATTRS] || {};
        if (!attributeDecorations[name])
            return exports.DEFAULT_ATTR_TYPE;
        return attributeDecorations[name].type;
    };
    AttrTrait.addAttr = function (ctor, name, type) {
        // validate
        if (process.env.NODE_ENV === "development") {
            // test and warn for uppercase characters because DOM will lowercase them
            if (type === AttrType.DOM_TRANSPARENT && /[ABCDEFGHIJKLMNOPQRSTUVWXYZ]/g.test(name.toString())) {
                core_1.st.warn("The attribute " + ctor.name + "." + name + " is DOM_TRANSPARENT and thus has a bad naming. It should be like: " + name.toLowerCase());
            }
            if (core_1.st.dom.isStandardHTMLAttribute(name)) {
                core_1.st.error("The attribute " + ctor.name + "." + name + " is a standard HTML element attribute. It's value would be written directly to this.el, hiding away from @attr. Please choose a different name.");
            }
        }
        // init cache
        if (!ctor[exports.ATTRS]) {
            ctor[exports.ATTRS] = {};
        }
        // register
        ctor[exports.ATTRS][name] = {
            name: name,
            type: type,
        };
    };
    return AttrTrait;
}());
exports.AttrTrait = AttrTrait;
//# sourceMappingURL=attr.js.map